import React from 'react';
import { useDispatch } from 'react-redux';
import { resetFilters } from '../../../../store/actions';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';

const ResetFiltersButton = () => {
  const dispatch = useDispatch();

  return (
    <ButtonWithText
      variant="danger"
      icon="XCircle"
      iconColor="#e60b0b"
      content="Réinitialiser"
      onClick={() => {
        dispatch(resetFilters());
      }}
    />
  );
};
export default ResetFiltersButton;
